import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class ProductFilterOptions
*  Фильтр<br>
*/
export class ProductFilterOptions extends ActiveModel {

/**
  * createdBefore
  * Фильтр по дате создания (не позднее, не включая)<br>
  */
  @ActiveField()
  createdBefore?: string


/**
  * createdAfter
  * Фильтр по дате создания (не раньше, включительно)<br>
  */
  @ActiveField()
  createdAfter?: string


  /**
  * categoryId
  * Фильтр по идентификатору категории<br>  */
  @ActiveField()
  categoryId?: number


  /**
  * collectionId
  * Состав подборки (Manual или Rule) на канале витрины<br>  */
  @ActiveField()
  collectionId?: number


  /**
  * outOfStock
  * Если true, то показывать товары, которых нет в наличии<br>  */
  @ActiveField()
  outOfStock?: boolean


  /**
  * attrs
  * Фильтр по значениям атрибута, где: <br><br>ключ: идентификатор атрибута; <br><br>значение: список значений для фильтрации. <br><br>Пример для использования в query-части запроса:<br>`Filter.Attrs[0][0].min=10&Filter.Attrs[0][0].max=20&Filter.Attrs[0][1].min=30&Filter.Attrs[0][1].max=50&Filter.Attrs[0][2].val=100&Filter.Attrs[10][0].val=100`  */
  @ActiveField(() => undefined)
  attrs?: Record<string, array>
}
